import { useEffect, useMemo } from 'react';
var additionalParametersGlobal = {};
function addAdditionalParameters(additionalParameters) {
    Object.assign(additionalParametersGlobal, additionalParameters);
}
function getAdditionalParameters() {
    return additionalParametersGlobal;
}
function clearAdditionalParameters() {
    Object.keys(additionalParametersGlobal).forEach(function (key) { return delete additionalParametersGlobal[key]; });
}
/**
 * Hook for setting `additionalParameters` to send to Newton
 * @returns object - Object containing functions to get and add additional parameters
 */
export default function useAdditionalParameters() {
    useEffect(function () { return clearAdditionalParameters(); }, []);
    var returnVal = useMemo(function () { return ({ getAdditionalParameters: getAdditionalParameters, addAdditionalParameters: addAdditionalParameters }); }, []);
    return returnVal;
}
